/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import Constants from '../../Config/Config';
import Parser from 'html-react-parser';

class MetaData extends Component {
  render() {
    const {selectedmatBoard, matBoardPrice} = this.props;
    return (
      <div className="row">
        <div className="col-sm-6"><strong>Mat Board:</strong> {Parser(selectedmatBoard.get('name'))}</div>
        <div className="col-sm-6"><strong>Height:</strong> {selectedmatBoard.getIn(['mat_size', 'height'])}cm</div>
        <div className="col-sm-6"><strong>Width:</strong> {selectedmatBoard.getIn(['mat_size', 'width'])}cm</div>
        <div className="col-sm-6"><strong>Price:</strong> {Constants.Currency + matBoardPrice}</div>
      </div>
    );
  }
}
export default MetaData;